<template>
	<div class="">
		<div class="container" v-if="article">
			<div class="back-button-container">
				<a href="/writing-tr">
					<span class="material-icons back-icon" style="margin-top: 5px"
						>arrow_back_ios</span
					>Back
				</a>
			</div>
			<article class="article">
				<div class="image-container">
					<img
						class="article-image"
						:src="`${apiUrl}${article.attributes.image.data.attributes.formats.medium.url}`"
					/>
					<div class="image-overlay"></div>
				</div>
				<div class="content-padding">
					<header class="article-header">
						<h1 class="article-title">{{ article.attributes.title }}</h1>
						<div class="meta-info">
							<span class="material-icons">person</span>
							<span>Abdullah Gürsoy</span>
							<span class="meta-separator">|</span>
							<span class="material-icons">calendar_today</span>
							<span>{{ article.attributes.publish_date }}</span>
						</div>
					</header>
					<div class="prose">
						<vue-markdown>{{ article.attributes.content }}</vue-markdown>
					</div>
					<footer class="article-footer"></footer>
				</div>
			</article>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import VueMarkdown from "vue-markdown-v2";

export default {
	components: { VueMarkdown },
	data() {
		return {
			apiUrl: "https://gursoy.me/strapi",
			article: null,
		};
	},
	mounted() {
		axios
			.get(
				`${this.apiUrl}/api/blog-ens?filters[slug][$eq]=${this.$route.params.slug}&populate=image`
			)
			.then((response) => {
				const { data } = response.data;
				this.article = data[0];
			});
	},
	methods: {},
};
</script>

<style lang="css" scoped>
body {
	font-family: "Inter", sans-serif;
	background-color: #f9fafb;
	color: #1f2937;
	margin: 0;
	padding: 0;
}
.container {
	margin-left: auto;
	margin-right: auto;
	padding-left: 1rem;
	padding-right: 1rem;
	padding-top: 2rem;
	padding-bottom: 2rem;
	max-width: 56rem;
}
@media (min-width: 768px) {
	.container {
		padding-top: 3rem;
		padding-bottom: 3rem;
	}
}
@media (min-width: 1024px) {
	.container {
		padding-top: 4rem;
		padding-bottom: 4rem;
	}
}
.article {
	background-color: #ffffff;
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
		0 4px 6px -2px rgba(0, 0, 0, 0.05);
	border-radius: 0.75rem;
	overflow: hidden;
}
.image-container {
	position: relative;
}
.article-image {
	width: 100%;
	height: 16rem;
	object-fit: cover;
}
@media (min-width: 768px) {
	.article-image {
		height: 20rem;
	}
}
@media (min-width: 1024px) {
	.article-image {
		height: 24rem;
	}
}
.image-overlay {
	position: absolute;
	inset: 0;
	background-color: rgba(0, 0, 0, 0.3);
}
.content-padding {
	padding: 1.5rem;
}
@media (min-width: 768px) {
	.content-padding {
		padding: 2.5rem;
	}
}
@media (min-width: 1024px) {
	.content-padding {
		padding: 3rem;
	}
}
.article-header {
	margin-bottom: 2rem;
}
.article-title {
	font-size: 1.875rem;
	line-height: 2.25rem;
	font-weight: 700;
	color: #111827;
	margin-bottom: 1rem;
	line-height: 1.25;
}
@media (min-width: 768px) {
	.article-title {
		font-size: 2.25rem;
		line-height: 2.5rem;
	}
}
@media (min-width: 1024px) {
	.article-title {
		font-size: 3rem;
		line-height: 1;
	}
}
.meta-info {
	display: flex;
	align-items: center;
	font-size: 0.875rem;
	line-height: 1.25rem;
	color: #6b7280;
}
.meta-info .material-icons {
	margin-right: 0.5rem;
	font-size: 1rem;
}
.meta-separator {
	margin-left: 0.5rem;
	margin-right: 0.5rem;
}
.prose {
	color: #374151;
	line-height: 1.75;
	font-size: 1.125rem;
	max-width: none;
}
.prose >>> p {
	margin-bottom: 1.5rem !important;
}
.article-footer {
	margin-top: 2.5rem;
	padding-top: 2rem;
	border-top: 1px solid #e5e7eb;
}
.footer-actions {
	display: flex;
	align-items: center;
	gap: 1rem;
}
.action-button {
	display: flex;
	align-items: center;
	color: #4b5563;
	padding: 0.5rem 1rem;
	border-radius: 0.5rem;
	border: 1px solid #d1d5db;
	transition-property: color, border-color;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	transition-duration: 200ms;
	background-color: transparent;
	cursor: pointer;
	font-size: 0.875rem;
}
.action-button .material-icons {
	margin-right: 0.5rem;
	font-size: 1.25rem;
}
.action-button:hover {
}
.action-button.like-button:hover {
	color: #2563eb;
	border-color: #3b82f6;
}
.action-button.comment-button:hover {
	color: #16a34a;
	border-color: #22c55e;
}
.action-button.share-button:hover {
	color: #9333ea;
	border-color: #a855f7;
}

.back-button-container {
	display: flex;
	justify-content: end;
	padding-top: 10px;
	padding-bottom: 10px;
}

.back-button-container a {
	font-size: 1.875rem;
	line-height: 2.25rem;
	font-weight: 700;
	color: #6b7280;
	margin-bottom: 1rem;
	line-height: 1.25;
	text-decoration: none;
}

@media (max-width: 768px) {
	.prose {
		font-size: 1rem;
	}

	.back-button-container a {
		font-size: 1.5rem;
		margin-bottom: 10px;
	}

	.back-button-container .back-icon {
		font-size: 1.2rem;
	}

	.container {
		padding-right: 1.1rem;
		padding-left: 1.1rem;
	}

	.content-padding {
		padding: 1.1rem;
	}
}
</style>
